import { Controller } from "@hotwired/stimulus";

// Category tabs plus the horizontal card carousel, on the theme's own classes:
// .wu-tab/.is-active for the tabs, .wu-card-row/.is-hidden for the rows, and
// the .wu-arrow buttons scrolling the visible row one screenful at a time.
export default class extends Controller {
  static targets = ["tab", "row", "rows"];

  connect() {
    this.onScroll = () => this.updateArrows();
    this.rowTargets.forEach((row) => row.addEventListener("scroll", this.onScroll, { passive: true }));
    window.addEventListener("resize", this.onScroll, { passive: true });
    this.updateArrows();
  }

  disconnect() {
    this.rowTargets.forEach((row) => row.removeEventListener("scroll", this.onScroll));
    window.removeEventListener("resize", this.onScroll);
  }

  select(event) {
    const group = event.currentTarget.dataset.tab;
    this.tabTargets.forEach((tab) => tab.classList.toggle("is-active", tab.dataset.tab === group));
    this.rowTargets.forEach((row) => row.classList.toggle("is-hidden", row.dataset.tabGroup !== group));
    this.updateArrows();
  }

  prev() { this.scrollBy(-1); }
  next() { this.scrollBy(1); }

  // ---- internals ----

  activeRow() {
    return this.rowTargets.find((row) => !row.classList.contains("is-hidden"));
  }

  // One card plus the grid gap; the row falls back to most of its own width.
  step(row) {
    const card = row.querySelector(".med-card");
    return card ? card.offsetWidth + 24 : row.clientWidth * 0.8;
  }

  scrollBy(direction) {
    const row = this.activeRow();
    if (!row) return;
    const step = this.step(row);
    const perScreen = Math.max(1, Math.floor(row.clientWidth / step));
    row.scrollBy({ left: direction * step * perScreen, behavior: "smooth" });
  }

  // Arrows sit vertically centred on the covers and disable at either end;
  // a row that fits entirely hides them altogether.
  updateArrows() {
    const row = this.activeRow();
    if (!row || !this.hasRowsTarget) return;
    const wrap = this.rowsTarget;
    const cover = row.querySelector(".med-card-cover");
    if (cover) {
      const top = cover.getBoundingClientRect().top - wrap.getBoundingClientRect().top + cover.offsetHeight / 2;
      wrap.style.setProperty("--arrowTop", `${Math.round(top)}px`);
    }
    const max = row.scrollWidth - row.clientWidth - 2;
    const prev = wrap.querySelector(".wu-arrow-prev");
    const next = wrap.querySelector(".wu-arrow-next");
    if (prev) prev.disabled = row.scrollLeft <= 2;
    if (next) next.disabled = row.scrollLeft >= max;
    const arrows = wrap.querySelector(".wu-arrows");
    if (arrows) arrows.classList.toggle("is-nocarousel", row.scrollWidth <= row.clientWidth + 4);
  }
}
